// Opsi ApexCharts biar ikut tema, gak nyentuh warna seri/data.
export const CHART_TEXT_COLOR = { light: '#455a64', dark: '#e9f2fc' };
export const CHART_TEXT_MUTED_COLOR = { light: '#5f6e7a', dark: '#9db3cb' };
export const CHART_BORDER_COLOR = { light: '#e3e9f1', dark: '#33445e' };

function mode(theme) {
  return theme === 'dark' ? 'dark' : 'light';
}

export function chartThemeOptions(theme) {
  const chartMode = mode(theme);
  const foreColor = CHART_TEXT_COLOR[chartMode];
  const mutedColor = CHART_TEXT_MUTED_COLOR[chartMode];
  const borderColor = CHART_BORDER_COLOR[chartMode];

  return {
    theme: { mode: chartMode },
    chart: { foreColor, background: 'transparent' },
    grid: { borderColor },
    tooltip: { theme: chartMode },
    xaxis: {
      labels: { style: { colors: mutedColor } },
      axisBorder: { color: borderColor },
      axisTicks: { color: borderColor },
    },
    yaxis: {
      labels: { style: { colors: mutedColor } },
    },
    legend: {
      labels: { colors: foreColor },
    },
  };
}

function isPlainObject(value) {
  return value !== null && typeof value === 'object' && !Array.isArray(value);
}

function deepMerge(base, override) {
  if (!isPlainObject(base) || !isPlainObject(override)) return override;
  const result = { ...base };
  Object.keys(override).forEach((key) => {
    result[key] = deepMerge(base[key], override[key]);
  });
  return result;
}

// warna label sumbu yang disetel sendiri (biasanya = warna seri) jangan ditimpa tema
function mergeAxis(axis, themedAxis) {
  const merged = deepMerge(axis, themedAxis);
  const ownColors = axis && axis.labels && axis.labels.style && axis.labels.style.colors;
  if (ownColors) merged.labels.style.colors = ownColors;
  return merged;
}

// tema menang buat chrome (foreColor/grid/tooltip/theme.mode/axis label), sisanya dari options aslinya
export function mergeChartTheme(options, theme) {
  const source = options || {};
  const themed = chartThemeOptions(theme);
  // sparkline sengaja tanpa sumbu, jangan dikasih opsi sumbu
  if (source.chart && source.chart.sparkline && source.chart.sparkline.enabled) {
    delete themed.xaxis;
    delete themed.yaxis;
    delete themed.legend;
  }
  const merged = deepMerge(source, themed);
  if (themed.xaxis) merged.xaxis = mergeAxis(source.xaxis, themed.xaxis);
  if (themed.yaxis) {
    // yaxis bisa array (multi-sumbu), tema ditempel ke tiap sumbu biar show:false dll gak hilang
    merged.yaxis = Array.isArray(source.yaxis)
      ? source.yaxis.map((axis) => mergeAxis(axis, themed.yaxis))
      : mergeAxis(source.yaxis, themed.yaxis);
  }
  return merged;
}
